


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import * as esri from 'esri-leaflet';
import SearchManager from '@/components/SearchManager.vue';
import ListingFilter from '@/components/ListingFilter.vue';

@Component({
    components: {
        SearchManager,
        ListingFilter,
    },
})
export default class LeafletMap extends Vue {


    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 415;

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        // if (action.type === 'zoomToSelected') {
        //     this.zoomToSelected();
        // }
    });

    get map(): L.Map {
        return this.$store.state.map;
    }

    get config() {
        return this.$store.state.config;
    }

    get isLoggedIn(): boolean {
        return this.$store.state.isLoggedIn;
    }

    get zoom() {
        return this.$store.state.zoom;
    }

    get centerLat() {
        return this.$store.state.centerLat;
    }

    get centerLon() {
        return this.$store.state.centerLon;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    get isLandscape(): boolean {
        return this.$q.screen.width > this.$q.screen.height;
    }

    public createMap() {
        const lSW: L.LatLngTuple = [this.config.mapDefault.maxBounds[0][0], this.config.mapDefault.maxBounds[0][1]];
        const lNE: L.LatLngTuple = [this.config.mapDefault.maxBounds[1][0], this.config.mapDefault.maxBounds[1][1]];

        const lMapOptions: L.MapOptions = {
            zoomControl: false,
            maxBounds: new L.LatLngBounds(lSW, lNE),
            minZoom: this.config.mapDefault.minZoom,
            maxZoom: this.config.mapDefault.maxZoom,
        };

        const lMap: L.Map = L.map('map', lMapOptions);
        lMap.on('load', this.onLoad);

        lMap.on('zoomend', (evt: L.LeafletEvent) => {
            console.log('zoomend');
            const lZoom = lMap.getZoom();

            this.$store.dispatch('setZoom', lZoom);

            if (lZoom >= 16) {
                L.DomUtil.addClass(lMap.getContainer(), 'crosshair-cursor-enabled');
            } else {
                L.DomUtil.removeClass(lMap.getContainer(), 'crosshair-cursor-enabled');
            }
        });

        lMap.on('click', (e: L.LeafletMouseEvent) => {

            if (e.originalEvent.defaultPrevented) {
                return;
            }

            const lZoom = lMap.getZoom();
            if (lZoom >= 16) {
                this.$store.dispatch('parcelClick', e.latlng);
            }
        });

        lMap.on('moveend', () => {
            console.log('map moveend');
            if (this.map) {
                const mapCenter: L.LatLng = this.map.getCenter();
                this.$store.dispatch('mapMoveEnd', mapCenter);
            }
        });

        const MapLoadingSpinner = L.Control.extend({
            options: {
                position: 'bottomleft',
            },
            onAdd: (map: L.Map) => {
                const container = L.DomUtil.get('spinner');
                return container;
            },
        });
        lMap.addControl(new MapLoadingSpinner());

        // restore the stored map state
        if (this.zoom !== -1 && this.centerLat !== -1 && this.centerLon !== -1) {
            lMap.setView([this.centerLat, this.centerLon], this.zoom);
        } else {
            // const lCenter: L.LatLngTuple = [this.config.mapDefault.center[0], this.config.mapDefault.center[1]];
            lMap.setView([this.config.mapDefault.center[0], this.config.mapDefault.center[1]], this.config.mapDefault.zoom);
        }

        this.$store.dispatch('setMap', lMap);

        this.$store.dispatch('initLayers');

        L.control.zoom({
            position: 'topleft',
        }).addTo(lMap);

        this.$store.dispatch('initGeoLocation');
        this.$store.dispatch('initWalkTimes');

        this.setMapWrapperHeight();
    }

    public onLoad() {
        console.log('onLoad');
        // Get a reference to the loader's div
        const loaderDiv: HTMLElement | null = document.getElementById('loader-wrapper');

        if (loaderDiv === null) {
            return;
        }

        // When the transition ends remove loader's div from display
        // so that we can access the map with gestures or clicks
        loaderDiv.addEventListener('transitionend', () => {
            if (loaderDiv) {
                loaderDiv.style.display = 'none';
            }
        }, true);
        // Kick off the CSS transition
        loaderDiv.style.opacity = '0.0';
    }

    // public initMapEvents() {
    // }



    public zoomHome() {
        const latLngs: L.LatLng[] = [];
        // for (const uid of Object.keys(this.deviceLayers)) {
        //     latLngs.push(this.deviceLayers[uid].getLatLng());
        // }
        // if (latLngs.length > 0) {
        //     this.getMap().fitBounds(L.latLngBounds(latLngs));
        // } else {
        //     this.$store.dispatch('notify', 'No device locations found');
        // }
    }

    public createHomeControl() {
        const HomeControl = L.Control.extend({
            onAdd: (map: L.Map) => {
                const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leafletControlHome');
                container.style.backgroundImage = 'url(home-24px.svg)';
                container.style.backgroundColor = 'white';
                container.style.backgroundPosition = 'center';
                container.style.width = '26px';
                container.style.height = '26px';
                container.onclick = () => {
                    this.zoomHome();
                };
                return container;
            },

            onRemove: (map: L.Map) => {
                // Nothing to do here
            },
        });

        const hc = new HomeControl({ position: 'topleft' });
        hc.addTo(this.map);
    }

    // public refreshMap() {
    //     if (this.map) {
    //         // there is a 200ms animation effect so this does nothin if you do it right away
    //         setTimeout(() => {
    //             this.map.invalidateSize(true);
    //         }, 200);
    //     }
    // }

    public mounted() {
        console.log('LeafletMap: mounted()');
        this.createMap();
        window.onresize = this.setMapWrapperHeight;
    }

    public setMapWrapperHeight() {
        this.$nextTick(function() {
            if (this.isMobile) {
                const height = window.innerHeight - 50;

                // @ts-ignore
                document.getElementById('mapWrapper').style.height = height + 'px';
            } else {
                const height = window.innerHeight ;

                // @ts-ignore
                document.getElementById('mapWrapper').style.height = height + 'px';
            }
        });
    }

    public beforeDestroy() {
        this.unsubscribe();
    }
}
